import { t } from "i18next";
import { SplitButton } from "primereact/splitbutton";

export default class ActionButtonBuilder {
    constructor(detailUrl) {
        this.items = [];
        this.detailUrl = detailUrl;        
    }


    addEditOption(url) {
        this.items.push({
            label: t('global.editButton'),
            icon: 'mdi mdi-pencil',
            className: 'menu-item',
            url: url,
            command: e => {
                e.originalEvent.preventDefault();
                window.location.href = url;
            }
        });
        return this;
    }

    addOption(label, icon, url, command) {
        this.items.push({
            label,
            icon,
            className: 'menu-item',
            command,
            url
        });
        return this;
    }

    build() {
        return (
            <div className='split-button' onClick={e => e.preventDefault()}>
                <a href={this.detailUrl}>
                    <SplitButton
                        buttonClassName='split-button'
                        label={t('global.detailsButton')}
                        icon='pi pi-eye'
                        onClick={e => {
                            e.preventDefault();
                            window.location.href = this.detailUrl;
                        }}
                        model={this.items}
                        id='details-button'
                    />
                </a>                
            </div>
        );
    }
}